import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home9',
  templateUrl: './home9.component.html',
  styleUrls: ['./home9.component.scss']
})
export class Home9Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home9-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home9-page');
  }
}
